import { Link } from 'react-router-dom';

function LegalStub({ title }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4" style={{ backgroundColor: '#FBF6EF' }}>
      <div className="max-w-md text-center">
        <img src="/brand/logo-round.png" alt="" className="w-12 h-12 rounded-full mx-auto mb-4" />
        <h1 className="text-2xl font-extrabold mb-2" style={{ color: '#5B2D1F' }} data-testid="legal-page-title">{title}</h1>
        <p className="text-base mb-6" style={{ color: '#6B4A3A' }}>
          Coming soon. Contact us at{' '}
          <a href="mailto:support@heritagecompass.app" className="font-bold underline" style={{ color: '#D77A52' }}>
            support@heritagecompass.app
          </a>
        </p>
        <Link to="/" className="text-sm font-bold" style={{ color: '#D77A52' }} data-testid="legal-back-link">&larr; Back to home</Link>
      </div>
    </div>
  );
}

export function PrivacyPage() { return <LegalStub title="Privacy Policy" />; }
export function TermsPage() { return <LegalStub title="Terms of Service" />; }
export function DisclaimerStubPage() { return <LegalStub title="Disclaimer" />; }
